import { combineReducers } from "redux";

import auth from "./reducers/authReducer";
import dashboard from "./reducers/dashboardReducer";
import store from "./reducers/sroreReducers";
import product from "./reducers/productReducer";
// import order from './reducers/orderReducer';
import branchReducer from "./reducers/branchReducer";

const rootReducer = combineReducers({
  auth,
  dashboard,
  store,
  product,
  // order,
  branchReducer,
});

export default rootReducer;
